<template>
    <div class="research-literature">
        <div class="filter-bar">
            <div class="filter-item">
                <span class="filter-label">分类</span>
                <el-select size="small" v-model="filters.category" placeholder="全部" clearable>
                    <el-option
                        v-for="item in categoryOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                </el-select>
            </div>
            <div class="filter-actions">
                <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button size="small" type="danger" plain icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
            </div>
        </div>

        <el-table
            class="literature-table"
            :data="pageList"
            :header-cell-style="headerCellStyle"
            stripe
            size="small"
        >
            <el-table-column
                type="index"
                label="序号"
                width="70"
                align="center"
                :index="indexMethod"
            />
            <el-table-column prop="title" label="标题" min-width="220" show-overflow-tooltip />
            <el-table-column prop="abstract" label="摘要" min-width="320" show-overflow-tooltip />
            <el-table-column prop="category" label="分类" width="120" align="center" />
        </el-table>

        <el-pagination
            class="page-wrap"
            background
            layout="total, prev, pager, next, jumper"
            :current-page="pageInfo.pageNum"
            :page-size="pageInfo.pageSize"
            :total="pageInfo.total"
            @current-change="changePage"
        />
    </div>
</template>

<script>
const MOCK_LIST = [
    {
        id: 1,
        title: '黄芪内服联合西药对2型糖尿病患者的疗效观察',
        abstract: '观察黄芪内服联合常规西药对2型糖尿病患者血糖控制及临床症状的改善情况。',
        category: 'RCT',
    },
    {
        id: 2,
        title: '中医药治疗糖尿病肾病的系统评价与Meta分析',
        abstract: '系统评价中医药干预糖尿病肾病的有效性与安全性，并开展Meta分析。',
        category: '系统评价',
    },
    {
        id: 3,
        title: '针灸干预糖尿病周围神经病变的随机对照试验',
        abstract: '评估针灸治疗糖尿病周围神经病变在神经传导速度及症状评分方面的疗效。',
        category: 'RCT',
    },
    {
        id: 4,
        title: '糖尿病中医证候分布规律的横断面研究',
        abstract: '分析糖尿病患者中医证候分布特点，为辨证分型提供流行病学依据。',
        category: '观察性研究',
    },
    {
        id: 5,
        title: '人参皂苷对糖尿病大鼠胰岛功能保护作用的实验研究',
        abstract: '探讨人参皂苷对糖尿病大鼠胰岛β细胞功能及氧化应激指标的影响。',
        category: '实验研究',
    },
    {
        id: 6,
        title: 'Traditional Chinese Medicine for Type 2 Diabetes: A Systematic Review',
        abstract: '系统综述中医药治疗2型糖尿病的临床证据，评估疗效与安全性。',
        category: '系统评价',
    },
    {
        id: 7,
        title: '六味地黄丸联合二甲双胍治疗气阴两虚型糖尿病临床观察',
        abstract: '观察六味地黄丸联合二甲双胍对气阴两虚型糖尿病患者血糖及证候积分的影响。',
        category: 'RCT',
    },
    {
        id: 8,
        title: '中西医结合治疗糖尿病足溃疡的疗效Meta分析',
        abstract: '对中西医结合治疗糖尿病足溃疡的随机对照研究进行Meta分析。',
        category: '系统评价',
    },
    {
        id: 9,
        title: '消渴病病因病机古今文献述评',
        abstract: '梳理消渴病病因病机的古今文献认识，总结病机演变与辨证思路。',
        category: '综述',
    },
    {
        id: 10,
        title: '葛根芩连汤改善胰岛素抵抗的分子机制研究',
        abstract: '从分子通路层面探讨葛根芩连汤改善胰岛素抵抗的作用机制。',
        category: '实验研究',
    },
    {
        id: 11,
        title: '中药复方干预糖尿病视网膜病变的临床疗效观察',
        abstract: '评价中药复方对糖尿病视网膜病变患者视力及眼底改变的干预效果。',
        category: 'RCT',
    },
    {
        id: 12,
        title: '针灸治疗糖尿病胃轻瘫的随机对照研究',
        abstract: '比较针灸与常规治疗对糖尿病胃轻瘫患者胃排空及症状评分的差异。',
        category: 'RCT',
    },
    {
        id: 13,
        title: 'Herbal Medicine and Glycemic Control: An Observational Cohort Study',
        abstract: '观察中草药干预与血糖控制之间的关联，分析真实世界应用情况。',
        category: '观察性研究',
    },
    {
        id: 14,
        title: '糖尿病中医诊疗指南更新要点解读',
        abstract: '解读糖尿病中医诊疗指南更新要点，梳理诊断、辨证与治疗推荐。',
        category: '综述',
    },
    {
        id: 15,
        title: '丹参注射液对糖尿病心肌病变保护作用的实验研究',
        abstract: '研究丹参注射液对糖尿病心肌病变模型心肌损伤及炎症指标的保护作用。',
        category: '实验研究',
    },
];

const EMPTY_FILTERS = {
    category: '',
};

export default {
    name: 'ResearchLiterature',
    data() {
        return {
            filters: { ...EMPTY_FILTERS },
            appliedFilters: { ...EMPTY_FILTERS },
            categoryOptions: ['RCT', '系统评价', '观察性研究', '实验研究', '综述'],
            allList: MOCK_LIST,
            pageInfo: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            headerCellStyle: {
                background: '#F5F7FA',
                color: '#303133',
                fontWeight: 'bold',
            },
        };
    },
    computed: {
        filteredList() {
            const { category } = this.appliedFilters;
            return this.allList.filter((item) => {
                if (category && item.category !== category) return false;
                return true;
            });
        },
        pageList() {
            const { pageNum, pageSize } = this.pageInfo;
            const start = (pageNum - 1) * pageSize;
            return this.filteredList.slice(start, start + pageSize);
        },
    },
    watch: {
        filteredList: {
            immediate: true,
            handler(list) {
                this.pageInfo.total = list.length;
                const maxPage = Math.max(1, Math.ceil(list.length / this.pageInfo.pageSize) || 1);
                if (this.pageInfo.pageNum > maxPage) {
                    this.pageInfo.pageNum = maxPage;
                }
            },
        },
    },
    methods: {
        indexMethod(index) {
            return (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize + index + 1;
        },
        handleSearch() {
            this.appliedFilters = { ...this.filters };
            this.pageInfo.pageNum = 1;
        },
        handleReset() {
            this.filters = { ...EMPTY_FILTERS };
            this.appliedFilters = { ...EMPTY_FILTERS };
            this.pageInfo.pageNum = 1;
        },
        changePage(page) {
            this.pageInfo.pageNum = page;
        },
    },
};
</script>

<style lang="less" scoped>
.research-literature {
    .filter-bar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 16px;
        margin-bottom: 16px;
    }

    .filter-item {
        display: flex;
        align-items: center;

        .filter-label {
            margin-right: 8px;
            font-size: 14px;
            color: #303133;
            white-space: nowrap;
        }

        .el-select {
            width: 140px;
        }
    }

    .filter-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button--primary {
            background: #165DFF;
            border-color: #165DFF;
        }
    }

    .literature-table {
        width: 100%;

        ::v-deep .el-button--text {
            color: #165DFF;
            padding: 0 4px;
        }
    }

    .page-wrap {
        margin-top: 16px;
        text-align: right;
    }
}
</style>
